<script lang="ts" setup>
import ArticleItem from "@/components/ArticleItem.vue";
import { useItemStore } from "@/itemStore";

const itemStore = useItemStore();
</script>

<template>
  <ArticleItem v-for="(item, nr) in itemStore.getItems" :key="item.id" :item="item" :nr="nr" />
</template>
